/** Upper-cases the first char of input string */
export const capitalize = (input) => `${input.charAt(0).toUpperCase()}${input.substring(1)}`;
export const isPromise = (value) => 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
Boolean(value && typeof value.then === 'function' && typeof value.catch === 'function');
export const BEGIN_LOGGING_TEXT = 'Begin';
export const END_LOGGING_TEXT = 'End';
//# sourceMappingURL=decoratorUtils.js.map